module.exports = __webpack_public_path__ + "static/media/drumKitProject.9bff435f.png";